import React from 'react';

export default function FormPage2({
  averageCostPerPint,
  setAverageCostPerPint,
  averageSalePricePerPint,
  setAverageSalePricePerPint,
  gotoResultPage,
}) {
  return (
    <div className="draught-wastage__page draught-wastage__form">
      <div className="draught-wastage__text-holder">
        <p className="draught-wastage__light draught-wastage__small-text">
          Answer the questions below to find out
        </p>
        <div>
          <div>
            <label className="draught-wastage__icon-pint">
              What is the average cost you pay wholesale for a pint?
            </label>
            <input
              placeholder="0.00"
              type="number"
              value={averageCostPerPint}
              onChange={(e) => setAverageCostPerPint(e.target.value)}
              required
              step=".01"
            />
          </div>
          <div>
            <label className="draught-wastage__icon-price">
              What is the average price your customers pay for a pint?
            </label>
            <input
              placeholder="0.00"
              type="number"
              value={averageSalePricePerPint}
              onChange={(e) => setAverageSalePricePerPint(e.target.value)}
              required
              step=".01"
            />
          </div>
          <button onClick={(event) => {
            gotoResultPage(event);
          }} >Calculate your loss &gt;</button>
        </div>
      </div>
    </div>
  );
}
